import activateForm from './forms/activateForm';

export default () => {
  Array.from(document.querySelectorAll('.form')).forEach((form) => {
    activateForm($(form));
  });
};
